import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit, faInfoCircle, faTrash } from '@fortawesome/free-solid-svg-icons'
import DashboardHeader from '../../Header/DashboardHeader';
import ReactTooltip from "react-tooltip";
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../DashboardLeftMenu';
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import { HOST_URL } from '../api/Api';
import AdvanceDataTable from '../../UI/Table/AdvanceDataTable';
import Spining from '../../UI/Spining/Spining';
import DeleteModal from '../campaign/Rcs/DeleteModal';
import Axios from '../../../axios/Axios';
import { handleUserLog } from '../../Utils/Utils';

class SmsTemplateList extends Component {
	constructor() {

		const lStorage = JSON.parse(localStorage.getItem("login"));
		const userId = lStorage?.user?.userId;
		const userToken = lStorage?.token;

		super();
		this.state = {
			SmsTemplateList: null,
			user_id: userId,
			token: userToken,
			successShow: false,
			successMessage: "",
			bgColor: '',
			loading: false,
			showDeletePopup: false,
			deleteId: '',
			deleteTemplateId: ''
		}
	}

	componentDidMount() {
		this.dltTemplateListData();
	}

	dltTemplateListData = async () => {
		let paramData = {
			user_id: this.state.user_id,
			method: "retrieve",
			token: this.state.token
		}
		let { data } = await Axios.post(`${HOST_URL}/dlt_template.php`, paramData);
		if (data.success === true) {
			this.setState({ SmsTemplateList: data.data });
		}
	}

	deleteConfirmation = (id, template_id) => {
		this.setState({ showDeletePopup: true, deleteId: id, deleteTemplateId: template_id });
	}

	deleteDltTemplate = async () => {
		document.querySelector('body').scrollTo(0, 0);
		let paramData = {
			user_id: this.state.user_id,
			id: this.state.deleteId,
			template_id: this.state.deleteTemplateId,
			method: "delete",
			token: this.state.token
		}
		let { data } = await Axios.post(`${HOST_URL}/dlt_template.php`, paramData)
		if (data.success === true) {
			this.setState({ successShow: true });
			this.setState({ successMessage: data.message });
			this.setState({ bgColor: "alert alert-success alert-dismissible" });
			handleUserLog("" , "deleted_dlt_template" , "sms" , data.message , "sms_template_management" , "" , "")
			//window.location.reload(); 
		} else {
			this.setState({ successShow: true });
			this.setState({ bgColor: "alert alert-danger alert-dismissible" });
			this.setState({ successMessage: data.message });
			handleUserLog("" , "deleted_dlt_template" , "sms" , data.message , "sms_template_management" , "" , "")
		}
	}

	DLT_TEMPLATE_DATA = [
		{
			name: "Action",
			selector: (row) =>
				<span>
					<Link to={'/dashboard/template-management/edit/' + row.id}>
						<span  title="Edit Template" className="badge bg-primary"> <FontAwesomeIcon icon={faEdit} /> </span>
					</Link>

					<span title="Delete Template" onClick={() => this.deleteConfirmation(row.id, row.template_id)} className="badge bg-danger ml-3"> <FontAwesomeIcon icon={faTrash} /> </span>
				</span>,
			sortable: true,
		},
		{
			name: "Entity ID",
			selector: (row) => row.entityid,
			sortable: true,
			width: "200px"
		},
		{
			name: "Template ID",
			cell: (row) => row.template_id,
			sortable: true,
			width: "200px"
		},
		{
			name: "Template Name",
			selector: (row) => row.template_name,
			sortable: true,
		},
		{
			name: "Template Content",
			selector: (row, i) =>
				<>
					Message <span data-tip data-for={"registerTip" + i} style={{ cursor: 'pointer', fontSize: 15, }} > <FontAwesomeIcon icon={faInfoCircle} color='#008aff' /></span>
					<ReactTooltip className="tooltip" html={true} id={"registerTip" + i} place="bottom" effect="solid">
						{row.template_msg}
					</ReactTooltip>
				</>,
			sortable: true,
		},
		{
			name: "Sender ID",
			selector: (row) => row.senderid,
			sortable: true,
		},
		{
			name: "Is Unicode",
			selector: (row) => row.enable_unicode === 1 ? 'Yes' : 'No',
			sortable: true,
		},
		{
			name: "Create Date",
			selector: (row) => row.created_date,
			sortable: true,
		},
	];

	render() {
		document.querySelector('body').scrollTo(0, 0);
		return (

			<div className="wrapper">
				<DashboardLeftMenu />
				<div className="main">
					<DashboardHeader />
					<main className="content">
						{this.state.loading && <Spining />}
						<div className="container-fluid p-0">
							<div className="row mb-2 mb-xl-3">
								<div className="col-auto d-none d-sm-block">
									<h3><strong>DLT Template </strong> List </h3>
								</div>

								<div className="col-auto ml-auto text-right mt-n1">
									<span onClick={() => handleUserLog("" , "click_add_dlt_template_button" , "sms" , "User Click on add dlt template button" , "sms_template_management" , "" , "")}>
									<Link className="btn btn-primary btn-sm" to="/dashboard/template-management"> <FontAwesomeIcon icon={faPlus} color='' />  Add DLT Template</Link>
									</span>
								</div>

							</div>


							{
								this.state.successShow ?
									<div className={this.state.bgColor} role="alert">
										<button type="button" className="close" data-dismiss="alert" aria-label="Close">
											<span aria-hidden="true">×</span>
										</button>
										<div className="">
											{this.state.errorMessage}
										</div>
									</div>
									:
									null
							}


							<div className="row justify-content-center">
								{
									this.state.SmsTemplateList ?

										// <table className="table table-hover  project  my-0">
										// 	<thead>
										// 		<tr>

										// 			<th>Action</th>
										// 			<th>Entity ID</th>
										// 			<th>Template ID</th>
										// 			<th>Template Name</th>
										// 			<th>Template Content</th>
										// 			<th>Sender ID</th>
										// 			<th>Is Unicode</th>
										// 			<th>Create Date</th>


										// 		</tr>
										// 	</thead>
										// 	<tbody>

										// 		{
										// 			this.state.SmsTemplateList.data.map((itam, i) =>
										// 				<tr key={i}>

										// 					<td>
										// 						<Link to={'/dashboard/template-management/edit/' + itam.id}>
										// 							<span title="Edit Template" className="badge bg-primary"> <FontAwesomeIcon icon={faEdit} /> </span>
										// 						</Link>

										// 						<span title="Delete Template" onClick={() => this.deleteDltTemplate(itam.id, itam.template_id)} className="badge bg-danger ml-3"> <FontAwesomeIcon icon={faTrash} /> </span>

										// 					</td>

										// 					<td>{itam.entityid}</td>
										// 					<td>{itam.template_id}</td>
										// 					<td>{itam.template_name}</td>
										// 					<td>
										// 						Message <span data-tip data-for={"registerTip" + i} style={{ cursor: 'pointer', fontSize: 15, }} > <FontAwesomeIcon icon={faInfoCircle} color='#008aff' /></span>
										// 						<ReactTooltip className="tooltip" html={true} id={"registerTip" + i} place="bottom" effect="solid">
										// 							{itam.template_msg}
										// 						</ReactTooltip>
										// 					</td>

										// 					<td className="">
										// 						{itam.senderid}
										// 					</td>

										// 					<td className="">
										// 						{itam.enable_unicode === 1 ? 'Yes' : 'No'}
										// 					</td>




										// 					<td>{itam.created_date}</td>



										// 				</tr>)
										// 		}

										// 	</tbody>
										// </table>
										<AdvanceDataTable
											tableCell={this.DLT_TEMPLATE_DATA}
											tableData={this.state.SmsTemplateList}
											isLoading={this.state.loading}
											pagination={true}
										/>
										: <div className="text-center">
											<div className="card-body">
												<img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
												<p>No SMS Template Yet</p>
											</div>
										</div>
								}
							</div>
						</div>
						<DeleteModal show={this.state.showDeletePopup} onClose={() => this.setState({ showDeletePopup: false })} onDelete={this.deleteDltTemplate} />
					</main>

					<DashboardFooter />
				</div>
			</div>




		);
	}
}

export default SmsTemplateList;